import React from "react";
import SeoArticleEmbeddedComponent from "componentLayout/SEO/SeoArticleEmbeddedComponent";
import {useGetSeoPage} from "contexts/SeoContext";
import {useSsoContext} from "contexts/authSSOContext";

const FooterFourDesktop = () => {
    const { isLoggedInSso } = useSsoContext();

    const seoPage = useGetSeoPage();
    const articleText = (seoPage?.pageArticle || "").replace(/_/g, " ");
    if (articleText !== "SSR") {
        if (!articleText.length || !articleText) return null;
    }
    if (isLoggedInSso) return null;
  return (
    <section id="footerFourDesktop" className="pt-16 pb-16 borderTop">
      <div className="width-1200 m-auto ">
        <SeoArticleEmbeddedComponent />
      </div>
    </section>
  );
};

export default FooterFourDesktop;
